// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2Hrwv","header":"MergedInvoice_header__3HjVz"};